import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import TextField from "components/ui/controls/text-field/text-field";
import Switch from "components/ui/controls/switch/Switch";
import { FaCalendarAlt, FaClock, FaUserCheck, FaUnlock, FaInfo, FaBorderStyle } from "react-icons/fa";
import InfoMessage from "components/ui/controls/info-message/info-message";

const DateDepartRetraite = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);

  // Style pour les cartes modernes
  const modernCardStyle = {
    display: "flex",
    alignItems: "center",
    padding: "16px 20px",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: "#E5E7EB",
    borderRadius: "12px",
    background: "white",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    marginBottom: "12px",
    position: "relative",
  };

  const modernCardSelectedStyle = {
    ...modernCardStyle,
    borderColor: "#4F46E5",
    background: "linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(99, 102, 241, 0.08) 100%)",
    boxShadow: "0 4px 20px rgba(79, 70, 229, 0.15), 0 2px 8px rgba(79, 70, 229, 0.1)",
  };

  const iconStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%)",
    marginRight: "16px",
    color: "#6B7280",
  };

  const selectedIconStyle = {
    ...iconStyle,
    background: "linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)",
    color: "white",
  };
  const textFieldModernStyle = {
    border: "2px solid #E5E7EB",
    borderRadius: "8px",
    background: "white",
    fontWeight: "600",
    textAlign: "center",
    padding: "8px 12px",
    fontSize: "12px",
    minWidth: "50px",
    transition: "all 0.3s ease",
  };

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row>
              <Column fill>
                <div>
                  <h3
                    style={{
                      fontWeight: "600",
                      color: "#1F2937",
                      marginBottom: "16px",
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    }}
                  >
                    <CardBoxHeader style={{ marginTop: 0 }} icon={<FaCalendarAlt />}>
                      Options de départ à la retraite
                    </CardBoxHeader>
                  </h3>

                  {/* À l'âge légal */}
                  <div
                    style={context.state["DepartAgeLegal" + ClientConjoint] ? modernCardSelectedStyle : modernCardStyle}
                    onClick={(e) => context.handleDepartRetraite(ClientConjoint, "DepartAgeLegal")(e)}
                  >
                    <div style={context.state["DepartAgeLegal" + ClientConjoint] ? selectedIconStyle : iconStyle}>
                      <FaCalendarAlt />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "14px", fontWeight: "600", color: "#1F2937" }}>À l'âge légal</div>
                      <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "2px" }}>Départ à l'âge minimum légal de départ en retraite</div>
                    </div>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: context.state["DepartAgeLegal" + ClientConjoint] === true ? "2px solid #4F46E5" : "2px solid #D1D5DB",
                        background: context.state["DepartAgeLegal" + ClientConjoint] ? "#4F46E5" : "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {context.state["DepartAgeLegal" + ClientConjoint] && <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "white" }}></div>}
                    </div>
                  </div>

                  {/* À l'âge choisi */}
                  <div
                    style={context.state["DepartAgeChoisi" + ClientConjoint] ? modernCardSelectedStyle : modernCardStyle}
                    onClick={(e) => context.handleDepartRetraite(ClientConjoint, "DepartAgeChoisi")(e)}
                  >
                    <div style={context.state["DepartAgeChoisi" + ClientConjoint] ? selectedIconStyle : iconStyle}>
                      <FaClock />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "14px", fontWeight: "600", color: "#1F2937" }}>À l'âge personnalisé</div>
                      <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "2px" }}>Choisir un âge précis de départ</div>
                      {context.state["DepartAgeChoisi" + ClientConjoint] && (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "12px",
                            marginTop: "12px",
                            padding: "12px",
                            background: "rgba(79, 70, 229, 0.05)",
                            borderRadius: "8px",
                          }}
                        >
                          <TextField
                            value={context.state["DepartAgeChoisiSelect" + ClientConjoint]}
                            onChange={context.handleDepartRetraite(ClientConjoint, "DepartAgeChoisiSelect")}
                            xs
                            style={textFieldModernStyle}
                          />
                          <span style={{ color: "#6B7280", fontSize: "14px" }}>ans et</span>
                          <TextField
                            value={context.state["DepartMoisChoisiSelect" + ClientConjoint]}
                            onChange={context.handleDepartRetraite(ClientConjoint, "DepartMoisChoisiSelect")}
                            xs
                            style={textFieldModernStyle}
                          />
                          <span style={{ color: "#6B7280", fontSize: "14px" }}>mois</span>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: context.state["DepartAgeChoisi" + ClientConjoint] ? "2px solid #4F46E5" : "2px solid #D1D5DB",
                        background: context.state["DepartAgeChoisi" + ClientConjoint] ? "#4F46E5" : "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {context.state["DepartAgeChoisi" + ClientConjoint] && <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "white" }}></div>}
                    </div>
                  </div>

                  {/* À la date du */}
                  <div
                    style={context.state["DepartDateChoisi" + ClientConjoint] ? modernCardSelectedStyle : modernCardStyle}
                    onClick={(e) => context.handleDepartRetraite(ClientConjoint, "DepartDateChoisi")(e)}
                  >
                    <div style={context.state["DepartDateChoisi" + ClientConjoint] ? selectedIconStyle : iconStyle}>
                      <FaCalendarAlt />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "14px", fontWeight: "600", color: "#1F2937" }}>À une date précise</div>
                      <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "2px" }}>Départ à une date calendaire spécifique</div>
                      {context.state["DepartDateChoisi" + ClientConjoint] && (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            marginTop: "12px",
                            padding: "12px",
                            background: "rgba(79, 70, 229, 0.05)",
                            borderRadius: "8px",
                          }}
                        >
                          <TextField value="01" disabled xs style={textFieldModernStyle} />
                          <span style={{ color: "#6B7280", fontSize: "16px" }}>/</span>
                          <TextField
                            value={context.state["MoisDepartDateChoisiInput" + ClientConjoint]}
                            onChange={context.handleDepartRetraite(ClientConjoint, "MoisDepartDateChoisiInput")}
                            xs
                            style={textFieldModernStyle}
                          />
                          <span style={{ color: "#6B7280", fontSize: "16px" }}>/</span>
                          <TextField
                            value={context.state["AnneeDepartDateChoisiInput" + ClientConjoint]}
                            onChange={context.handleDepartRetraite(ClientConjoint, "AnneeDepartDateChoisiInput")}
                            dataType="uint"
                            xs
                            style={{ ...textFieldModernStyle, minWidth: "70px" }}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: context.state["DepartDateChoisi" + ClientConjoint] ? "2px solid #4F46E5" : "2px solid #D1D5DB",
                        background: context.state["DepartDateChoisi" + ClientConjoint] ? "#4F46E5" : "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {context.state["DepartDateChoisi" + ClientConjoint] && <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "white" }}></div>}
                    </div>
                  </div>

                  {/* Au taux plein */}
                  <div
                    style={context.state["DepartAgeTauxPlein" + ClientConjoint] ? modernCardSelectedStyle : modernCardStyle}
                    onClick={(e) => context.handleDepartRetraite(ClientConjoint, "DepartAgeTauxPlein")(e)}
                  >
                    <div style={context.state["DepartAgeTauxPlein" + ClientConjoint] ? selectedIconStyle : iconStyle}>
                      <FaUserCheck />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "14px", fontWeight: "600", color: "#1F2937" }}>Au taux plein</div>
                      <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "2px" }}>Départ automatique dès l'obtention du taux plein</div>
                    </div>
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: context.state["DepartAgeTauxPlein" + ClientConjoint] ? "2px solid #4F46E5" : "2px solid #D1D5DB",
                        background: context.state["DepartAgeTauxPlein" + ClientConjoint] ? "#4F46E5" : "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {context.state["DepartAgeTauxPlein" + ClientConjoint] && <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "white" }}></div>}
                    </div>
                  </div>
                </div>
              </Column>
            </Row>
            {/* Section déblocage avec switch moderne */}
            <Row>
              <Column fill>
                <div
                  style={{
                    // background: "linear-gradient(135deg, #FEF3C7 0%, #FFFBEB 100%)",
                    background: "#f0f9ff",
                    border: "1px solid #bae6fd",
                    borderRadius: "12px",
                    padding: "20px",
                    marginTop: "16px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "white",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        color: "#0369a1",
                        flexShrink: 0,
                      }}
                    >
                      <FaUnlock size={18} />
                    </div>

                    <div style={{ flex: 1 }}>
                      <div style={{ marginBottom: "12px" }}>
                        <Switch
                          checked={context.state["UnlockAgeOuverture" + ClientConjoint]}
                          onChange={(checked) => context.handleCheckChange("UnlockAgeOuverture" + ClientConjoint)(null, checked)}
                          label="Déblocage de l'âge d'ouverture des droits"
                          color="primary"
                          size="sm"
                        />
                      </div>

                      <InfoMessage
                        text={
                          <>
                            
                            Le logiciel intègre automatiquement les âges d'ouverture des droits propres à chaque régime. Nous vous déconseillons vivement d'activer cette option sauf si vous
                            souhaitez prévoir un départ anticipé au titre du handicap par exemple.
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
};

export default DateDepartRetraite;
